// @flow

import moment from 'moment'
import { call, put, takeEvery } from 'redux-saga/effects'
import SMConst from 'frontend_core/dist/constants/sm-const'
import { createActions, handleActions } from 'redux-actions'
import RestClient from 'frontend_core/dist/rest/client'
import { type Room as RoomType } from 'types/room'
import Path from 'routes/path'

/**
 ************************************************************
 * 初期ステート
 ************************************************************
 **/

const initialState = {
  roomDetail: {},
  inquiry: {},
  isSendingInquiry: false,
  isSuccessInquiry: false,
  isFailedInquiry: false,
}

/**
 ************************************************************
 * ActionTypes
 ************************************************************
 **/

const actionTypes = {
  SET_ROOM_DETAIL: 'SET_ROOM_DETAIL',
  UPDATE_ROOM_DETAIL: 'UPDATE_ROOM_DETAIL',

  SEND_INQUIRY: 'SEND_INQUIRY',
  SUCCESS_INQUIRY: 'SUCCESS_INQUIRY',
  FAILED_INQUIRY: 'FAILED_INQUIRY',
}

/**
 ************************************************************
 * Actions
 ************************************************************
 **/

export const actions = createActions(
  actionTypes.SET_ROOM_DETAIL,
  actionTypes.UPDATE_ROOM_DETAIL,
  actionTypes.SEND_INQUIRY,
  actionTypes.SUCCESS_INQUIRY,
)

/**
 ************************************************************
 * reducer
 ************************************************************
 **/

export const reducer = handleActions(
  {
    [actionTypes.SET_ROOM_DETAIL]: (state, action) => ({
      ...state,
      roomDetail: action.payload,
    }),
    [actionTypes.UPDATE_ROOM_DETAIL]: (state, action) => ({
      ...state,
      roomDetail: Object.assign(
        {},
        {
          ...state.roomDetail,
          ...action.payload,
        },
      ),
    }),
    [actionTypes.SEND_INQUIRY]: state => ({
      ...state,
      inquiry: {},
      isSendingInquiry: true,
      isSuccessInquiry: false,
      isFailedInquiry: false,
    }),
    [actionTypes.SUCCESS_INQUIRY]: (state, action) => ({
      ...state,
      inquiry: action.payload,
      isSendingInquiry: false,
      isSuccessInquiry: true,
      isFailedInquiry: false,
    }),
    [actionTypes.FAILED_INQUIRY]: state => ({
      ...state,
      isSendingInquiry: false,
      isSuccessInquiry: false,
      isFailedInquiry: true,
    }),
  },
  initialState,
)

/**
 ************************************************************
 * API連携 非同期アクション
 ************************************************************
 **/

type InquiryParams = {
  eventType: string,
  useType: string,
  capacity: string,
  minPrice?: string,
  maxPrice?: string,
  preview?: string,
  description: string,
  startedAt?: moment,
  endedAt?: moment,
}
function* sendInquiry(action: {
  payload: { room: RoomType, params: InquiryParams },
}) {
  const { room, params } = action.payload
  const formData = new FormData()
  formData.append('event_type', params.eventType)
  formData.append('use_type', params.useType)
  formData.append('capacity', params.capacity)
  if (params.minPrice) {
    formData.append('min_budget', params.minPrice)
  }
  if (params.maxPrice) {
    formData.append('max_budget', params.maxPrice)
  }
  if (params.preview) {
    formData.append('need_preview', params.preview)
  }
  formData.append('content', params.description)

  if (params.startDate && params.endDate) {
    const startDate = moment(params.startDate)
      .utc()
      .startOf('day')
    const endDate = moment(params.endDate)
      .utc()
      .startOf('day')
    // 12/1-12/1指定なら12/1からの一日間、12/1-12/2指定なら12/1からの二日間とする
    const diffDays = endDate.diff(startDate, 'days') + 1
    formData.append('rent_type', SMConst.RentType.DayTime)
    for (var i = 0; i < diffDays; i++) {
      formData.append(
        'reserved_schedules[][started_at]',
        moment(startDate)
          .add(i, 'days')
          .toISOString(),
      )
      formData.append('reserved_schedules[][duration]', 1440)
      formData.append('reserved_schedules[][is_session_start]', 0)
    }
  }

  try {
    const inquiry = yield call(
      RestClient.postFormData,
      `/1/rooms/${room.uid}/inquiries`,
      formData,
    )
    yield put(actions.successInquiry(inquiry))

    window.location.href = Path.sentInquiry(
      room.space.username,
      room.uid,
      inquiry.uid,
    )
  } catch (e) {
    yield put(actionTypes.FAILED_INQUIRY)
  }
}

/**
 ************************************************************
 * saga
 ************************************************************
 **/

export const roomSagas = [takeEvery(actionTypes.SEND_INQUIRY, sendInquiry)]



// WEBPACK FOOTER //
// ./src/redux/modules/room.js